// utilities
import './utilities/animations';
import './utilities/bg-hires-img';

// lightbox
require('fslightbox');

// components
import './components/main-navigation';
import './components/header';
import './components/accordion';
import './components/slider';
import './components/reviews-slider';
import './components/video-carousel';
import './components/doctor-achievements';
import './components/pop-up';